import React from 'react'
import { makeStyles } from '@material-ui/core'
import { calculateTimingType, calculateTimingValue } from '../../../../utils'
import { scheduledTriggers } from '../../../../options'
import { calculateTimeBefore } from '../../../../utils'

const useStyles = makeStyles(() => ({
  commsLengthContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    minWidth: '90px',
  },
}))

export const CommunicationsLength = ({ communications, trigger }) => {
  let comms = [...communications]

  if (trigger && scheduledTriggers.includes(trigger.triggerType.name)) {
    comms = comms.map(comm => ({
      ...comm,
      time_delay: calculateTimeBefore(trigger.target_value, comm.time_delay),
    }))
  }
  const { minDelay, maxDelay } = comms.reduce(
    (acc, communication) => {
      if (
        acc.minDelay === null ||
        Number(communication.time_delay) < acc.minDelay
      ) {
        acc.minDelay = Number(communication.time_delay)
      }
      if (
        acc.maxDelay === null ||
        Number(communication.time_delay) > acc.maxDelay
      ) {
        acc.maxDelay = Number(communication.time_delay)
      }
      return acc
    },
    { minDelay: null, maxDelay: null },
  )

  const { commsLengthContainer } = useStyles()

  if (minDelay === null || maxDelay === null) {
    return <div>-</div>
  }

  return (
    <div className={commsLengthContainer}>
      {minDelay === maxDelay
        ? maxDelay === 0
          ? '0m'
          : `${Number(calculateTimingValue(maxDelay))}${
              calculateTimingType(maxDelay)[0]
            }`
        : `${Number(calculateTimingValue(minDelay))}${
            calculateTimingType(minDelay)[0]
          } - ${Number(calculateTimingValue(maxDelay))}${
            calculateTimingType(maxDelay)[0]
          }`}
    </div>
  )
}
